export default {
  RELATIONSHIP_TYPES_REQUEST: 'RELATIONSHIP_TYPES_REQUEST',
  RELATIONSHIP_TYPES_SUCCESS: 'RELATIONSHIP_TYPES_SUCCESS',
  RELATIONSHIP_TYPES_FAILURE: 'RELATIONSHIP_TYPES_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/RelationshipTypesConstants.js